import React from 'react';
import RoomTypeGallery from './RoomTypeGallery';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useZitoneoPreview } from '../../../contexts/ZitoneoContentContext';
import CategorySection from './CategorySection';

const RoomTypesList = () => {
    const translate = useTranslate();
    const { HotelRoomTypes } = useZitoneoPreview();

    return (
        <section
            className='zitoneo-section zitoneo-section--rooms'
            aria-labelledby='category-rooms'
        >
            <header className='service-section-web__header'>
                <div className='service-section__header-main'>
                    <h2
                        id='category-rooms'
                        className='service-section__header__title'
                    >
                        {translate('rooms')}
                    </h2>
                </div>
            </header>

            {HotelRoomTypes.map((roomType, ind) => (
                <article
                    className='room-preview'
                    key={`${roomType.MasterRoomName}-${ind}`}
                >
                    <RoomTypeGallery room={roomType} />
                    <div className='flex-column gap-40'>
                        {roomType.ServiceCategories.length
                            ? roomType.ServiceCategories.map(category => (
                                  <CategorySection
                                      key={category.Id}
                                      category={category}
                                      scope='room'
                                  />
                              ))
                            : null}{' '}
                    </div>
                </article>
            ))}
        </section>
    );
};

export default RoomTypesList;
